import React, { useState } from 'react';
import axios from 'axios';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';
import { RadioInput, TextArea } from 'uikit/inputs';

import { handleAxiosError, removeModal } from 'core/notifications';

import getAxiosConfig from '../helpers/getAxiosConfig';

import NewItemFormButtons from './newItemFormButtons';

import styles from '../styles/reportActivityModal.module.scss';

const ReportActivityModal = ({ id }) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [comment, setComment] = useState('');
  
  const handleSubmit = async () => {
    try {
      await axios(getAxiosConfig('report-activity', { comment, id, reason: selectedReason }));
    } catch (error) {
      return handleAxiosError(error);
    }
    
    removeModal();
  };

  const handleCancel = () => removeModal();

  const options = [{
    label: i18n.t('flagging-broken-link'),
    value: 'broken_link'
  }, {
    label: i18n.t('flagging-not-appropriate'),
    value: 'not_appropriate'
  }, {
    label: i18n.t('flagging-incorrect-content'),
    value: 'incorrect_content'
  }, {
    label: i18n.t('flagging-other'),
    value: 'other'
  }];

  return (
    <>
      <div className={styles.element}>
        <div className={styles.options}>
          <Typo className={styles.label} variant="b02" weight="medium">{i18n.t('reason-for-report')}</Typo>
          {options.map(({ label, value }) => (
            <RadioInput
              className={styles.radio}
              key={value}
              labelPosition="right"
              fieldId={value}
              value={value === selectedReason}
              label={label}
              updateField={() => setSelectedReason(value)}
              options={[]}
            />
          ))}
        </div>
        <div>
          <Typo className={styles.label} variant="b02" weight="medium">{i18n.t('additional-comment-optional')}</Typo>
          <TextArea
            value={comment}
            onChange={setComment}
          />
        </div>
      </div>
      <NewItemFormButtons 
        isFullScreen={false}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        submitText={i18n.t('submit')}
        isSubmitDisabled={!selectedReason}
      /> 
    </>
  );
};

ReportActivityModal.propTypes = {
  id: PropTypes.number.isRequired
};

export default ReportActivityModal;
